import { render, staticRenderFns } from "./FunFactsCard.vue?vue&type=template&id=3c7a4f27&"
import script from "./FunFactsCard.vue?vue&type=script&lang=js&"
export * from "./FunFactsCard.vue?vue&type=script&lang=js&"
import style0 from "./FunFactsCard.vue?vue&type=style&index=0&id=3c7a4f27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports